import { PageController } from '@client/components/_core/layout/PageController';
import { ClaimFlagEdit } from '@client/components/claims/ClaimFlagEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/claims/claim-flags/edit/$claimFlagId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit flag',
        },
    },
    params: {
        parse({ claimFlagId }) {
            return {
                claimFlagId: BigInt(claimFlagId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ClaimFlagEdit action={['edit', Route.useParams().claimFlagId]} />
        </PageController>
    );
}
